import React from 'react'
import Landing from '../components/Landing';
import Discounted from '../components/Discounted';
import Explore from '../components/Explore';
import Hightlight from '../components/Highlights';
import New from '../components/New';
// import TopItems from '../components/TopItems';
// import Banner from '../components/Banner';
import { Analytics } from "@vercel/analytics/react"
import NewItems from '../components/NewItems';
import Types from '../components/types/types';
// Import the functions you need from the SDKs you need

const Home = () => {
    return (
        <>
            <Analytics />
            {/* <Banner /> */}
            <Landing />
            <Hightlight />
            <Discounted />
            {/* <Types /> */}
            <New />
            {/* <NewItems /> */}
            {/* <TopItems /> */}
            <Explore />
        </>
    )
}

export default Home;
